import { Component, input, InputSignal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CmsBtn } from '@shared/ui/cms-btn/cms-btn';
import { CmsImage } from '@shared/ui/cms-image/cms-image';
import { CmsStyles } from '@shared/directives/cms-styles/cms-styles.directive';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';
import { ContactInfoBlock } from '@core/cms/landing.cms';

/** Renders the `footer-sections.contact-info-block` (logo, address and contact links). */
@Component({
    selector: 'app-footer-contact',
    imports: [TranslatePipe, CmsBtn, CmsImage, CmsStyles, TrustHtmlPipe],
    templateUrl: './footer-contact.html',
    styleUrl: './footer-contact.scss',
})
export class FooterContact {
    /** The CMS contact block to render. */
    public readonly contact: InputSignal<ContactInfoBlock> = input.required<ContactInfoBlock>();
}
